export const DIALOG_PORTAL_CONTAINER_ID = 'dailySellLimitsDialogPortalContainerId';
export const MAX_DAILY_SELL_LIMIT = 9999;
export const MIN_DAILY_SELL_LIMIT = 0;
